import { Badge } from 'framework7-react';
import React     from 'react';


export default function NotificationBadge({ count, ...props }) {
  if (count)
    return <Badge {...props}>{count}</Badge>;
  else
    return null;
}
